import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import { getDSetting } from "api/developmentResearchUser";
import { ISetting } from "interfaces/interface_setting";

interface RETURNTYPE {
  isLoading: boolean;
  data: ISetting;
}

const useSetting = (isCRDC?: boolean): RETURNTYPE => {
  const router = useRouter();
  const { locale } = router;

  const { isLoading, data, isFetching } = useQuery(
    isCRDC ? ["getDSetting", locale] : ["getMSetting", locale, "site"],
    () => getDSetting(locale, isCRDC ? undefined : "site")
  );

  return { isLoading: isLoading && isFetching, data: data?.data };
};

export default useSetting;
